export class User {
  constructor(currentUser) {
    this.id = currentUser.id;
  }

  getId = () => this.id;
}
